import React from 'react';
import { EMPTY_STRING, NASTRING } from '../../constants/StringConstants';
function CustomText({ dataSet = {}, property1, property2, formatter, seperator = ' ' }) {

    const renderBooleanField = (val) => {
        if (val != null || val !== undefined) {
            return !!val ? 'true' : 'false';
        } else {
            return '';
        }
    }

    if (dataSet === null || dataSet === undefined) {
        dataSet = {};
    }
    if (!property2) {
        if (dataSet && dataSet.hasOwnProperty(property1)) {
            return (
                <span className='value-text'>{(
                    typeof dataSet[property1] === 'boolean' ?
                        renderBooleanField(dataSet[property1]) :
                        formatter ?
                            formatter(dataSet[property1]) :
                            dataSet[property1]?.toString())
                    || EMPTY_STRING}</span>
            );
        } else {
            return (
                <span>{NASTRING}</span>
            );
        }
    } else {
        if (dataSet && (dataSet.hasOwnProperty(property1) || dataSet.hasOwnProperty(property2))) {
            return (
                <span className='value-text'>{!dataSet[property1] && !dataSet[property2] ? EMPTY_STRING : `${dataSet[property1] || EMPTY_STRING}${dataSet[property1] ? seperator : ''}${dataSet[property2] || EMPTY_STRING}`}</span>
            );
        } else {
            return (
                <span>{NASTRING}</span>
            );
        }
    }

}
export default CustomText;

